import { render } from "./CompanyBoard.vue?vue&type=template&id=70f3e582&ts=true"
import script from "./CompanyBoard.vue?vue&type=script&lang=ts"
export * from "./CompanyBoard.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__